import { useNavigate } from "react-router-dom";
import Logo from "./Logo";
import { addToDiscord } from "../utils/discord";

export default function SiteNav({ showCta = false }) {
  const navigate = useNavigate();
  return (
    <nav className="landing-nav">
      <div className="landing-nav-content">
        <div className="landing-logo" onClick={() => navigate("/")} style={{ cursor: "pointer" }}>
          <Logo size={32} />
          <span className="landing-logo-text">okeybot</span>
        </div>
        <div className="landing-nav-links">
          <button className="landing-nav-link" onClick={() => navigate("/")}>
            Home
          </button>
          <button className="landing-nav-link" onClick={() => navigate("/docs")}>
            Documentation
          </button>
          <button className="landing-nav-link" onClick={() => navigate("/dashboard")}>
            Dashboard
          </button>
          {showCta && (
            <button className="btn btn-primary" onClick={addToDiscord} data-umami-event="add_to_discord_site_nav">
              Add to Discord
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}
